import { render, staticRenderFns } from "./notice_info.vue?vue&type=template&id=dff21076&scoped=true"
import script from "./notice_info.vue?vue&type=script&lang=js"
export * from "./notice_info.vue?vue&type=script&lang=js"
import style0 from "./notice_info.vue?vue&type=style&index=0&id=dff21076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff21076",
  null
  
)

export default component.exports